module.exports = __webpack_public_path__ + "static/bon_achat-e928465064dd73d42a98ccdee7a84f7e.png";